import {Component, Input, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-upgrade-plan',
    templateUrl: './upgrade-plan.component.html',
    styleUrls: ['./upgrade-plan.component.scss']
})
export class UpgradePlanComponent implements OnInit {

    @Input() preview: string;
    @Input() picto: string;
    @Input() plan: string;

    constructor(public authenticationService: AuthenticationService) {
    }

    ngOnInit(): void {
    }

}
